import EduBox from './EduBox';
import { EduBoxFieldProps } from './index';

const View = ({ content }: { content: EduBoxFieldProps }) => {
  return <EduBox content={content} />;
};

export default View;
